import React from 'react';
import { getTeamMemberListPage } from 'api/group';
import { TTeamMemberDto } from 'types/group';

const useAllTeamMember = (acticeOnly?: boolean, enabled = true): [TTeamMemberDto[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TTeamMemberDto[]>([]);

    const fetchData = React.useCallback(async () => {
        try {
            setLoading(true);
            const result = await getTeamMemberListPage({
                current: 1,
                size: 200,
            });
            if (!result.error) {
                let _data = result?.data?.data?.records || [];
                if (acticeOnly) {
                    _data = _data.filter((item: TTeamMemberDto) => item.status === 'ACTIVE');
                }
                setData(_data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        if (enabled) {
            fetchData();
        }
    }, [fetchData, enabled]);

    return [data, loading, fetchData];
};

export default useAllTeamMember;
